module.exports = __webpack_public_path__ + "img/climber-game-avatar-catch.9002d791.png";